"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _User = _interopRequireDefault(require("../User"));
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var NavBanner = function NavBanner(props) {
  var className = props.className,
    style = props.style,
    onLogoClick = props.onLogoClick,
    userProps = props.userProps,
    responsive = props.responsive,
    children = props.children;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)("nav-banner");
  var classes = (0, _classnames.default)(prefixCls, className, {
    'responsive': responsive
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "".concat(prefixCls, "__logo"),
    onClick: onLogoClick
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon-logo"
  })), children, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__user--wrap")
  }, /*#__PURE__*/_react.default.createElement(_User.default, (0, _extends2.default)({
    className: "".concat(prefixCls, "__user")
  }, userProps, {
    reverse: true
  }))));
};
var _default = NavBanner;
exports.default = _default;